import Job from './Job';
import t from '../i18n/I18n';

/**
 * Extends the functionality of {@link Job} by allowing
 * the asynchronous task to be started at later time, via
 * the `start` method.
 *
 * Subclasses must implement the asynchronous task in
 * the `start` method. Upon success or error of the task,
 * emit the 'resolve' or 'reject' event to tell `this.promise`
 * to resolve or reject.
 */
export default class FutureJob extends Job {
  _started: boolean;
  _parent: FutureJob;
  _children: FutureJob[];

  constructor() {
    super();

    this._started = false;
    this._parent = null;
    this._children = [];

    this._promise = new Promise((resolve, reject) => {
      this.once('resolve', (...args) => {
        this._done = true;
        this.emit('change', this);
        this.removeAllListeners();
        resolve(...args);
      });

      this.once('reject', (...args) => {
        this._done = true;
        this.emit('change', this);
        this.removeAllListeners();
        reject(...args);
      });
    });
  }

  get started() {
    return this._started;
  }

  get description() {
    const status = this._done ? t('DONE') : this._canceled ? t('CANCELED') : this._started ? t('RUNNING') : t('WAITING');
    return {
      label: t('BACKGROUND_TASK') + ` (${status})`,
      tooltip: t('TASK_ID') + `: ${this._id}`,
      status
    };
  }

  get children() {
    return this._children;
  }

  set parent(value: FutureJob) {
    this._parent = value;
  }

  set children(value: FutureJob[]) {
    this._children = value;
    this._children.forEach((child) => {
      child.parent = this;
    });
  }

  start() {
    throw new Error('NotImplemented');
  }
}
